// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__12PYG","content":"LayoutSettings_content__2wYwW"};